import React from "react";
import ReactApexChart from "react-apexcharts";
import getChartColorsArray from "../../Components/Common/ChartDynamicColor";

const StackedColumnChart = ({ dataColors, periodData = [] }: any) => {
  const stackedColumnChartColors = getChartColorsArray(dataColors);

  const safeSeries = Array.isArray(periodData)
    ? periodData.filter(
        (s) =>
          Array.isArray(s?.data) &&
          s.data.length > 0 &&
          s.data.some((val: number) => val > 0)
      )
    : [];

  const options: any = {
    chart: {
      stacked: true,
      toolbar: {
        show: false,
      },
      zoom: {
        enabled: true,
      },
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: "15%",
      },
    },
    dataLabels: {
      enabled: false,
    },
    xaxis: {
      categories: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],
    },
    colors: stackedColumnChartColors || ["#556ee6", "#34c38f", "#f46a6a"],
    legend: {
      position: "bottom",
    },
    fill: {
      opacity: 1,
    },
  };
  const clonedSeries = JSON.parse(JSON.stringify(periodData || []));

  return (
    <React.Fragment>
      {safeSeries.length > 0 ? (
        <ReactApexChart
          options={options}
          series={clonedSeries}
          type="bar"
          height="359"
          className="apex-charts"
        />
      ) : (
        <p>No data found</p>
      )}
    </React.Fragment>
  );
};

export default StackedColumnChart;
